import { render, staticRenderFns } from "./ChristmasDestockingBanner.vue?vue&type=template&id=4b8fa572&name=christmas-destocking-banner&"
import script from "./ChristmasDestockingBanner.vue?vue&type=script&lang=js&"
export * from "./ChristmasDestockingBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasDestockingBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports